import { PageHero } from "@/components/Sections";
import { LeadForm } from "@/components/LeadForm";
import { Reveal } from "@/components/Reveal";
import { Tag, RefreshCcw, Calculator, HandCoins } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1763211321083-ccd63db5be94?w=1600";

const points = [
  { icon: Calculator, title: "Estimation de votre véhicule", desc: "Obtenez une estimation claire et rapide de la valeur de votre voiture." },
  { icon: RefreshCcw, title: "Solution de reprise", desc: "Reprenez votre ancien véhicule lors de l'achat d'un nouveau." },
  { icon: HandCoins, title: "Vente accompagnée", desc: "Nous vous accompagnons avant et après la vente, en toute transparence." },
];

export default function Sell() {
  return (
    <div data-testid="sell-page">
      <PageHero
        overline="Vendre mon véhicule"
        title="Vous avez un véhicule à vendre ?"
        subtitle="Contactez-nous pour obtenir une estimation et découvrir nos solutions de reprise ou de vente."
        image={HERO}
      />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid gap-6 sm:grid-cols-3">
        {points.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.08}>
            <div className="h-full bg-[#121212] border border-white/10 rounded-sm p-7">
              <p.icon className="h-7 w-7 text-[#C5A059]" />
              <h3 className="font-display text-lg font-semibold text-white mt-5">{p.title}</h3>
              <p className="text-sm text-neutral-400 mt-2 leading-relaxed">{p.desc}</p>
            </div>
          </Reveal>
        ))}
      </section>
      <section className="max-w-3xl mx-auto px-5 lg:px-8 pb-24">
        <Reveal>
          <div className="bg-[#0f0f0f] border border-white/10 rounded-sm p-8 lg:p-10">
            <div className="flex items-center gap-3 mb-6">
              <Tag className="h-6 w-6 text-[#C5A059]" />
              <h2 className="font-display text-2xl font-bold text-white">Demande d'estimation / reprise</h2>
            </div>
            <LeadForm
              type="vente"
              submitLabel="Demander une estimation"
              fields={[
                { name: "brand", label: "Marque", type: "text", placeholder: "Ex : Peugeot" },
                { name: "model", label: "Modèle", type: "text", placeholder: "Ex : 308" },
                { name: "year", label: "Année", type: "number", placeholder: "2019" },
                { name: "mileage", label: "Kilométrage", type: "number", placeholder: "85000" },
                { name: "fuel", label: "Énergie", type: "select", options: ["Essence", "Diesel", "Hybride", "Électrique"] },
                { name: "goal", label: "Objectif", type: "select", options: ["Vente", "Reprise", "Estimation simple"] },
                { name: "message", label: "Informations complémentaires", type: "textarea", full: true },
              ]}
            />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
